import { Color } from '@material-ui/core';

const green: Color = {
  50: '#e3f4f0',
  100: '#bae5da',
  200: '#8cd3c2',
  300: '#5ec1a9',
  400: '#3cb496',
  500: '#19a784',
  600: '#169f7c',
  700: '#129671',
  800: '#0e8c67',
  900: '#087c54',
  A100: '#abffdf',
  A200: '#78ffcb',
  A400: '#45ffb8',
  A700: '#2bffae',
};

export default green;
